// export const Animations = function () {
(function () {
    const $ = window.jQuery;

    if (isMobile()) {
        return;
    }

    // Setup animation className on all blocks.
    $('.entry-content > .axeweb-block').each(function (i) {
        if (i < 3) {
            return;
        }

        if (this.classList.contains('animation-ignored')) {
            return;
        }

        $(this).addClass('animated_arrival');
    })

    $(document).on("ready", scrollUpdate);
    $(document).on("scroll", scrollUpdate);

    function scrollUpdate() {
        // Detect bottom page position based on device.
        const pageTop = $(document).scrollTop() - $(window).height();

        // Calculate animation threshold based on ratio of the screen.
        const threshold = pageTop + (window.innerWidth / 100 * 90);

        // Find all animated sections.
        const tags = $(".animated_arrival");
        $(tags).each(function () {
            const $tag = $(this);

            // if (!$tag.parents('.body-container').length) {
            //     // Ignore sections that are not a part of "MainContent" wrapper.
            //     return;
            // }

            // Hide or show sections based on threshold.
            if (($tag.offset().top) < threshold) {
                // Show section.

                if ($tag.hasClass("visible")) {
                    // The section is already visible.
                    return;
                }

                $tag.addClass("visible");
            } else {
                // Hide section.

                $tag.removeClass("visible");
            }
        });
    }

    function isMobile() {
        return window.innerWidth < 1024;
    }
})();

// }
